import type RootStore from "stores/RootStore";
import type ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

/**
 * Shipping Module Route — starter version (2026-06-25).
 *
 * Three-tab module at /shipping (Bill of Lading, Shipping Log, Shipping
 * Schedule). Surface-level UI + backend skeleton so Premier has SOMETHING
 * to start using before the full shipping tooling is built out.
 *
 * Warms on entry: shipments, bills-of-lading, shipping-log-entries,
 * projects, panels — all kept small so the three tabs render without an
 * empty-flash. The day-of BoL flow lazily pulls panel-schedule-chips via
 * the composite endpoint inside Shipping.Body (date-coupled, so not
 * worth preloading).
 *
 * TODO(shipping): PDF gen for BoL, notification triggers on
 * status transitions, loading diagram editor, deeper validation.
 */
const ShippingRoute: RouteType = {
  name: "Shipping",
  path: "/shipping",
  title: "Shipping",
  layout: "/app",
  group: "Production",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  viewportCard: {
    header: {
      component: () => import("./Shipping.Page"),
      title: "Shipping",
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./Shipping.Body"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    try {
      const r = rootStore as unknown as Record<string, ServiceStore | undefined>;
      await Promise.allSettled([
        r.projectsStore?.find?.({ query: { $limit: 500 } }),
        r.panelsStore?.find?.({ query: { $limit: 1000 } }),
        r.shipmentsStore?.find?.({
          query: { $limit: 500, $sort: { shipDate: -1 } },
        }),
        r.billsOfLadingStore?.find?.({
          query: { $limit: 500, $sort: { generatedAt: -1 } },
        }),
        r.shippingLogEntriesStore?.find?.({
          query: { $limit: 500, $sort: { recordedAt: -1 } },
        }),
        r.shipmentPiecesStore?.find?.({ query: { $limit: 2000 } }),
      ]);
    } catch (error) {
      console.warn("[ShippingRoute] warm-load failed:", error);
    }
    return true;
  },
};

export default ShippingRoute;
